import React, { useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { VeribliLogo } from '../../assets/svgs/VeribliLogo';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Link } from '../../components/global/Link';
import { useAuth } from '../../assets/contexts/AuthContext';

interface ForgotPasswordError {
  email?: string;
  token?: string;
  password?: string;
  password_confirmation?: string;
  main?: string;
}

export const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const email = searchParams.get('email') ?? '';
  const [error, setError] = useState<ForgotPasswordError>({});
  const { resetPassword } = useAuth();

  const navigate = useNavigate();
  const handleResetPassword = async () => {
    const { errors } = await resetPassword(email, password, confirmPassword, token);
    if (errors) {
      setError(errors);
    } else {
      navigate('/signin');
    }
  };

  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      height='100vh'
      paddingBottom={6}
    >
      <Stack sx={{maxWidth: '500px', width: '100%'}} spacing={2} alignItems='center'>
        <Stack width='100%' justifyContent= 'center' alignItems='center'>
          <VeribliLogo />
        </Stack>
        <Stack width='80%' justifyContent= 'center' alignItems='center'>
          <Typography variant="h4" gutterBottom fontFamily='korolev-condensed' fontWeight='600' letterSpacing='1px'>
            Reset/set Your Password
          </Typography>
          <Typography variant="body2" gutterBottom fontStyle='italic' color='#DA0101'>
            {error.main}
          </Typography>
        </Stack>
        {
          email !== '' && token !== '' ? (
            <>
              <Stack
                component="form"
                width='100%'
                spacing={4}
              >
                <Stack width='100%'>
                  <Typography variant='body2' >Password</Typography>
                  <TextField
                    type="password"
                    variant="outlined"
                    value={password}
                    error={error.password ? true : false}
                    helperText={error?.password?.[0] ?? ''}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Stack>
                <Stack width='100%'>
                  <Typography variant='body2' >Renter Password</Typography>
                  <TextField
                    type="password"
                    variant="outlined"
                    value={confirmPassword}
                    error={error.password_confirmation ? true : false}
                    helperText={error?.password_confirmation?.[0] ?? ''}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </Stack>
              </Stack>
              <Stack alignItems='center' justifyContent='center' pt={2}>
                <Button 
                  type="submit" 
                  variant="contained" 
                  color="primary" 
                  sx={{ fontWeight: '900', textTransform: 'unset' }} 
                  onClick={handleResetPassword}
                >
                  Reset Password
                </Button>
              </Stack>
            </>
          ) : (
            <Stack
              width='100%'
              spacing={4}
              textAlign='center'
              justifyContent='center'
            >
              <p>Error: The password reset link is missing the required token and email parameters.</p>
            </Stack>
          )
        }
        <Stack pt={2}>
          <Link to="/signin">
            <Typography variant="body2" fontWeight='600'>
              Sign In
            </Typography>
          </Link>
        </Stack>
      </Stack>
    </Stack>
  );
};